import { createAction, props } from '@ngrx/store';
import { MFAOutcome, OneTimeRedemptionCashBack } from '@rd/core/mfa/types';
import {
  HttpError,
  PointsTransaction,
  Promocode,
  PromocodeUsage,
} from '@rd/types';
import { CashbackFormData } from '../../types';

export const SubmitCashbackForm = createAction(
  '[Cashback] Submit Checkout Form Data',
  props<{
    formData: CashbackFormData;
  }>(),
);

export const SubmitCashback = createAction(
  '[Cashback] Submit Cashback',
  props<{
    loyaltyProgramId: string;
    formData: CashbackFormData;
    promocode?: Promocode;
    // This property only for restoring promocode state
    // when we redirect from MFA
    promocodeUsage?: PromocodeUsage;
  }>(),
);

export const SubmitCashbackSuccess = createAction(
  '[Cashback] Submit Cashback Success',
  props<PointsTransaction>(),
);

export const SubmitCashbackFail = createAction(
  '[Cashback] Submit Cashback Fail',
  props<HttpError>(),
);

export const ClearCashbackError = createAction(
  '[Cashback] Clear Cashback Error',
);

export const HydrateCashback = createAction(
  '[Cashback] Hydrate Cashback MFA Data',
  props<{
    hydrationData: OneTimeRedemptionCashBack;
    outcome: MFAOutcome;
  }>(),
);
